var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHonduras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#338af3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.545 166.957 8.288 25.509h26.821l-21.698 15.764 8.289 25.509-21.7-15.765-21.7 15.765 8.289-25.509-21.699-15.764h26.821z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.545 278.261 8.288 25.51h26.821l-21.698 15.764 8.289 25.508-21.7-15.765-21.7 15.765 8.289-25.508-21.699-15.764h26.821z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.455 166.957 8.289 25.509h26.821l-21.699 15.764 8.289 25.509-21.7-15.765-21.7 15.765 8.289-25.509-21.699-15.764h26.822z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.455 278.261 8.289 25.51h26.821l-21.699 15.764 8.289 25.508-21.7-15.765-21.7 15.765 8.289-25.508-21.699-15.764h26.822z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 222.609 8.289 25.51h26.821l-21.699 15.764 8.289 25.508-21.7-15.765-21.7 15.765 8.289-25.508-21.699-15.764h26.821z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonduras);
export default __webpack_public_path__ + "static/media/honduras.b469f8d8b81c129bc0d7fe0bbd0f1453.svg";
export { ForwardRef as ReactComponent };